import MentionsOfficialAccountSelector from './MentionsOfficialAccountSelector';

export default MentionsOfficialAccountSelector;
